import { ReactKeycloakProvider } from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import "mapbox-gl/dist/mapbox-gl.css";
import ReactDOM from "react-dom/client";
import "react-quill/dist/quill.snow.css";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import store from "./app/store";
import Loader from "./components/ui/Loader";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.css";
import "./styles/override.css";

export const keycloak = new Keycloak({
  url: process.env.REACT_APP_AUTH_KEYCLOAK_API,
  realm: process.env.REACT_APP_REALM,
  // clientId: "admin-cli",
  clientId: process.env.REACT_APP_CLIENT_ID,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <ReactKeycloakProvider
    initOptions={{
      onLoad: "check-sso",
      silentCheckSsoRedirectUri:
        window.location.origin + "/silent-check-sso.html",
      pkceMethod: "S256",
      checkLoginIframe: false,
    }}
    onEvent={(event, error) => {
      console.log(error);
    }}
    LoadingComponent={<Loader />}
    authClient={keycloak}
  >
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </ReactKeycloakProvider>
  // </React.StrictMode>
);

reportWebVitals();
